export default __webpack_public_path__ + "static/codutech-2a89a14bcb2ba074d5fccec379f6e486.svg";